import { IState } from 'shared/store';

export const selectBestPlaceCheckoutEnabled = (state: IState) => state.featureToggle.isBestPlaceCheckoutEnabled;
